import React from "react";
import { useTranslation } from "react-i18next";

import { Button, Card, CardContent } from "@mui/material";
import tigomoney from "../../assets/logoTigo/togosvg2.svg";


function QrGenerate(props) {
  const [t] = useTranslation("global");

  const downloadQR = () => {
    const base64Url = `data:image/jpeg;base64,${tigo_url}`;
    let downloadLink = document.createElement("a");
    downloadLink.href = base64Url;
    downloadLink.download = "myqr.png";
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };
  let url = props.url;
  let data = Object.assign({}, props);
  delete data.url;
  const tigo_url = url;

  let fontSize = {
    fontSize: "25px",
  };

  let imageLogo = {
    marginLeft: "15px",
  };

  let buttonText = {
    textTransform: "none",
    marginBottom: "20px",
    textAlign: "center",
  };

  let alignCenter = {
    textAlign: "center",
  };

  let container = {
    margin: "0px auto",
    width: "fit-content",
    textAlign: "left",
  };

  let child = {
    margin: "0px auto",
    border: "solid 5px",
    width: "fit-content",
    padding: "15px",
    borderRadius: "20px",
    display: 'flex',
    alignItems: 'center',
  };

  return (
    <Card
      style={{
        borderRadius: "16px",
        boxShadow: "0px 4px 11px rgba(194, 209, 217, 0.46)",
      }}
    >
      <CardContent>
        <div style={container}>
          <h2 style={buttonText}>{t("QrGenerate.CodeQR")}</h2>

          <div id="newQR" style={child}>
            <img id="myqr" src={`data:image/jpeg;base64,${tigo_url}`} alt="Imagen" height={250} width={250} />

            <img id="logoTigo" style={imageLogo} height={220} src={tigomoney} alt="logo" />
          </div>
          <h3 style={{ color: "Gray" }}>
            <label style={fontSize}>{props.name}</label>
            <br></br>
            {"ID: " + props.idSucursal}
          </h3>

          <div style={alignCenter}>
            <Button onClick={downloadQR} style={buttonText} variant="contained" className="action-button">
              {" "}
              {t("QrGenerate.Download")}
            </Button>
          </div>
        </div>
      </CardContent>
    </Card>
  );
}

export default QrGenerate;
